<template>
  <div class="brief-content"
       :class="{'brief-content__print': isStaticView}">
    <div class="brief-content__right-menu">
      <base-select
          borderLess
          isGreyArrowColor
          :titleStyle="{
            color: '#2f404e !important',
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: '20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: 'fit-content',
            display: 'inline-block' }"
          :options="asanaOptions"
          :headerStyle="{
            padding: '0 10px',
            marginTop: '10px !important'
          }"
          :propListStyle="{
            top: 'inherit'
          }"
          @change="asanaSelect($event)">
            <img class="title-dropdown-menu__integration-logo"
                :src="require(`@/assets/integrations_logos/asana-logo.svg`)"/>
          </base-select>
    </div>
    <div v-if="briefContent.name !== ''" class="container brief-content__container">

      <div class="brief-content__common-info-wrapper">
        <CommonPageInfo :content="briefContent"
                        :isMetricsShown="true"
                        :writingStatusOptions="writingStatusOptions"
                        :contributorOptions="contributorOptions"
                        @urlAttributes="openUrlAttributesModal"
                        @changeWritingStatus="changeWritingStatus"
                        @changeContentBrief="changeContentBriefContributor"
                        @select-date="changeStatus({date: $event})"
                        @attachments="openAttachmentsModal"
                        @change-status="openChangeStatusModal"
                        @url-changed="updateUrl">
        </CommonPageInfo>
      </div>

      <div class="brief-content__header">
        <div class="brief-content__tabs">
          <router-link
            class="brief-content__tab"
            :to="{name: 'BriefStrategy', params: {id: briefId}}"
            active-class="brief-content__tab_active"
          >
            STRATEGY
          </router-link>
          <router-link
            class="brief-content__tab"
            :to="{name: 'CreationTab', params: {id: briefId}}"
            active-class="brief-content__tab_active"
          >
            OPTIMIZE
          </router-link>
          <router-link
            class="brief-content__tab"
            :to="{name: 'BriefPublishing', params: {id: briefId}}"
            active-class="brief-content__tab_active"
            v-if="publishingEnabled"
          >
            PUBLISH
          </router-link>
          <router-link
            class="brief-content__tab"
            :to="{name: 'BriefReporting', params: {id: briefId}}"
            active-class="brief-content__tab_active"
          >
            PROGRESS
          </router-link>
          <router-link
            class="brief-content__tab"
            :to="{name: 'BriefComparison', params: {id: briefId}}"
            active-class="brief-content__tab_active"
          >
            COMPARISON
          </router-link>
        </div>
        <!-- <base-page-title
          :title="pageTitle"
          :disabled="isCurrentUserClientCollaborator"
          :is-static-view="isStaticView"
          @change-slug-name="changeSlugName($event)"
          class="brief-content__title">
        </base-page-title> -->
      </div>

      <div class="brief-content__content-holder">
        <advanced-options
          v-if="showAdvancedFilters"
          class="brief-content__advanced"
          :options="advancedOptions"
          :predefinedOptions="_advancedFilters"
          @copy="copyFilters"
          :forceCalculate="isDataFetched"
          @apply-advanced="applyAdvancedOptions"/>

        <router-view @update-score="onScoreUpdated"
                   :urlId="briefContent.url_id"
                   :selectedAdvancedOptions="selectedAdvancedOptions" />

      </div>
    </div>
    <div v-else-if="!isDataFetched"
         class="brief-content__loader container">
      <base-loader/>
    </div>
    <div v-if="isDataUpdating" class="brief-content__update-loader" :style="loaderStyle">
      <base-loader class="brief-content__update-loader-ring"/>
    </div>
    <modal name="share"
           v-bind="shareModalProps"
    >
      <Share :link="link"
             :title="pageTitle"
             :userEmail="userEmail"
             @submit="shareSubmit($event)"
             @cancel="shareCancel()"/>
    </modal>
    <modal name="pdf"
           v-bind="shareModalProps"
    >
      <Share :link="link"
             :title="pageTitle"
             :userEmail="userEmail"
             :popupType="'pdf'"
             @submit="sharePdfSubmit($event)"
             @cancel="pdfCancel()"/>
    </modal>
    <modal name="url-attributes"
           v-bind="shareModalProps"
    >
      <UrlAttributes
        :briefId="briefId"
        @cancel="closeUrlAttributesModal"/>
    </modal>
    <modal name="integrations"
           v-bind="integrationModalProps"
    >
      <base-integration-menu :type="type"
                             :currentClientId="currentClientId"
                             :changeAccountLink="integrationLinks[type]"
                             :integrationMode="integrationMode"
                             :selectedIntegrations="selectedIntegrations"
                             :connectedServices="connectedServices"
                             :isSaveAsDefaults="isSaveAsDefaults"
                             mode="integrate"
                             @close="closeIntegrationChange" />
    </modal>
    <modal name="errorMessagePopup"
           v-bind="integrationModalProps">
      <ErrorMessagePopup @close="closeErrorMessagePopup" />
    </modal>
    <modal name="change-status"
           v-bind="statusModalProps"
    >
      <ChangeStatusPopup :brief="briefContent"
                         :type="changingType"
                         @apply="changeStatus"
                         @cancel="changeStatus"/>
    </modal>
    <modal name="confirm-asana-modal" v-bind="detachModalProps">
     <base-confirm-modal title="Are you sure you want to detach from Asana?"
                         @confirm="detachAsana"/>
    </modal>
    <modal name="attachmetns" v-bind="shareModalProps">
      <AttachmentsModal :attachments="nonPublishAttachments"
        :briefId="briefId"
        @close="closeAttachmentsModal"
        @update="getData(false)"/>
    </modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapActions, mapState } from 'vuex'
import helper from '@/services/Helper'
import Moment from 'moment'
import CommonPageInfo from './CommonPageInfo'
import Comments from './Comments'
import Share from './Share'
import baseModalProps from '@/common/BaseModalProps'
import ToasterService from '@/services/toasterService'
import ErrorMessagePopup from '@/features/integrations/ErrorMessagePopup'
import TitleDropdownMenu from './TitleDropdownMenu'
import UrlAttributes from './UrlAttributes'
import { default as ChangeStatusPopup, STATUS_TYPES } from './ChangeStatusPopup'
import _ from 'lodash'
import AdvancedOptions from '@/features/reports/common/advanced-options/AdvancedOptions'
import AttachmentsModal from './AttachmentsModal'
import { advancedFiltersMixins } from '@/features/reports/common/AdvancedFiltersMixins'
import {
  addOptionsToConfig,
  ADVANCED_OPTION_TYPE,
  contentBriefFieldsConfig,
  contentBriefCompetitionFieldsConfig
} from '@/features/reports/common/advanced-options/config'
import { INTEGRATIONS_MODE } from '@/common/BaseConstants'

const TAB = {
  STRATEGY: 'STRATEGY',
  CREATION: 'CREATION',
  REPORTING: 'REPORTING'
}
/**
 * Brief Content component
 * Is root component and is host for {@link ./StrategyTab} and {@link Reporting} via <router-view>
 */
export default {
  name: 'BriefContent',
  mixins: [advancedFiltersMixins],
  mounted () {
    const integrationStatus = this.integrationStatus
    if (integrationStatus.length) {
      try {
        const statusData = JSON.parse(integrationStatus)
        this.tempClientId = statusData.client_id
        this.type = statusData.type
        this.isSaveAsDefaults = true
        // TODO: move it to helper as a constants
        this.$modal.show('integrations')
      } catch (e) {
        console.log(e)
      } finally {
        // remove integration status from url
        this.$router.push(this.$route.path)
      }
    }
    if (this.isStaticView) {
      const footer = document.querySelector('footer')
      footer.hidden = true
    }
    this.titleInterval = setInterval(() => {
      if (document.title !== this.pageTitle) {
        document.title = this.pageTitle || 'AudienceKey'
      }
    }, 500)
    this.checkOnTop = _.throttle(() => {
      this.isOnTop = window.scrollY === 0
    }, 100, { leading: true, trailing: true })
    this.checkOnTop()
    window.addEventListener('scroll', this.checkOnTop)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.checkOnTop)
    clearInterval(this.titleInterval)
    this.resetBriefContent()
    rightMenuToggleStyles(true, true)
  },
  props: {
    isStaticView: {
      type: Boolean,
      default: false
    },
    integrationError: {
      type: String,
      default: ''
    },
    integrationStatus: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      /**
       * types of top right overflow menu items
       * */
      headerLinkTypes: {
        pdf: 'pdf',
        share: 'share',
        integrations: 'integrations'
      },
      titleInterval: null,
      type: null,
      isFormProcessing: false,
      baseModalProps,
      isEditorOpened: false,
      showCommentsSection: false,
      link: document.location.href,
      changingType: null,
      tempClientId: null,
      integrationLinks: null,
      isSaveAsDefaults: false,
      isDataUpdating: false,
      isDataFetched: false,
      tooltipOptions: {
        content: 'Coming soon',
        delay: { show: 100, hide: 1300 },
        classes: 'rfx-tooltip-arrow',
        trigger: 'hover'
      },
      isOnTop: true,
      checkOnTop: null,
      selectedAdvancedOptions: []
    }
  },
  components: {
    ChangeStatusPopup,
    CommonPageInfo,
    Share,
    ErrorMessagePopup,
    AdvancedOptions,
    UrlAttributes,
    AttachmentsModal,
  },
  computed: {
    ...mapState({
      isNavbarCollapsed: 'isNavbarCollapsed'
    }),
    ...mapState('rankZoneCommon', ['publishingEnabled']),
    ...mapState('briefContent', {
      integratedServices (state) {
        return state.briefContent.available_integrations
      },
      connectedServices (state) {
        return state.briefContent.integrations
      },
      isAsanaIntegrated (state) {
        return !!state.briefContent.available_integrations.find(i => i.name === 'asana')
      },
      selectedIntegrations (state) {
        return [state.briefContent._id]
      },
      briefContent: 'briefContent'
    }),
    ...mapState({
      userEmail: state => {
        return state.currentUser ? state.currentUser.email : ''
      },
      isCurrentSessionFetched: 'isCurrentSessionFetched',
      selectedClient: 'selectedClient'
    }),
    ...mapState('rankZoneCommon', {
      advancedOptions (state) {
        const page = this.$route.name.toLocaleLowerCase()
        let config = _.cloneDeep(['briefreporting', 'briefreportingprint'].includes(page)
          ? contentBriefFieldsConfig
          : contentBriefCompetitionFieldsConfig
        )
        addOptionsToConfig(config, state.scores, ADVANCED_OPTION_TYPE.SCORE)
        addOptionsToConfig(config, state.serpFeature, ADVANCED_OPTION_TYPE.SERP_FEATURE)
        if (['briefreporting', 'briefreportingprint'].includes(page)) {
          addOptionsToConfig(config, state.mismatchedUrls, ADVANCED_OPTION_TYPE.MISMATCHED_URLS)
        } else {
          addOptionsToConfig(config, state.attributes, ADVANCED_OPTION_TYPE.ATTRIBUTE)
        }
        return this.isClientDifficultyScoreEnabled ? config : config.filter(i => i.type !== ADVANCED_OPTION_TYPE.DIFF_SCORE)
      },
      writingStatusOptions (state) {
        return state.writingStatuses.map(helper.convertListToOptions)
      },
      contributorOptions (state) {
        return state.clientContributors.map(helper.convertListToOptions)
      }
    }),
    asanaOptions () {
      const opts = []
      if (this.isAsanaIntegrated) {
        opts.push({
          value: 'open',
          label: 'Open Associated Asana Task'
        }, {
          value: 'detach',
          label: 'Detach from Asana'
        })
      } else {
        opts.push({
          value: 'add',
          label: 'Add to Asana'
        })
      }
      return opts
    },
    briefId () {
      return this.$route.params.id
    },
    showAdvancedFilters () {
      return !(['briefpublishing', 'briefstrategy', 'briefstrategyprint', 'creationtab', 'creationtabprint'].includes(this.$route.name.toLocaleLowerCase()))
    },
    integrationModalProps () {
      const shareModalProps = {
        width: '610px'
      }
      return { ...baseModalProps, ...shareModalProps }
    },
    detachModalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    currentClientId () {
      return this.clientId || this.tempClientId
    },
    pageTitle () {
      return `${this.briefContent.name}`
    },
    commentsCount () {
      const length = this.briefContent.comments.length
      return length < 100 ? length : '99+'
    },
    shareModalProps: function () {
      const shareModalProps = {
        width: 690
      }
      return { ...this.baseModalProps, ...shareModalProps }
    },
    integrationMode () {
      return INTEGRATIONS_MODE.ASANA_ADD
    },
    statusModalProps: function () {
      const statusModalProps = {
        width: 500
      }
      return { ...this.baseModalProps, ...statusModalProps }
    },
    sortedComments () {
      return sortCommentsByTimestamp(this.briefContent.comments)
    },
    commentsGroupedByDay () {
      return groupCommentsByDate(this.briefContent.comments)
    },
    amountOfComments () {
      return this.briefContent.comments.length
    },
    isClientReady () {
      return this.briefContent._id.length > 0
    },
    isStrategy () {
      return this.tab === TAB.STRATEGY
    },
    isReporting () {
      return this.tab === TAB.REPORTING
    },
    loaderStyle () {
      const container = document.querySelector('.main-layout')
      const width = container ? `${container.clientWidth - this.navBarWidth}px` : '100%'
      return { 'left': `${this.navBarWidth}px`, 'width': width }
    },
    nonPublishAttachments() {
      return this.briefContent.attachements.filter(
        (img) => img[6].category !== 'Publishing'
      )
    }
  },
  methods: {
    ...mapActions('briefContent', [
      'getBriefContent',
      'resetBriefContent',
      'getComments',
      'updateScore',
      'addComment',
      'shareBrief',
      'sharePdf',
      'changeContentBrief',
      'getWordCloud',
      'getKeywordsSnapshot',
      'detachFromAsana'
    ]),
    ...mapActions('urlPlanning', ['changeWritingStatus']),
    onShowCommentsSection: function () {
      rightMenuToggleStyles(this.showCommentsSection)
      this.showCommentsSection = !this.showCommentsSection
    },
    /**
     * callback for top right overflow menu
     * It opens and Share {@link Share} modal
     * @param type - {@see #headerLinkTypes}
     */
    onHeaderButtonClick (type) {
      if (!this.briefContent.name) {
        return
      }
      const integratedService = _.cloneDeep(this.integratedServices).find(i => i.name === type)
      if (integratedService) {
        if (integratedService.url && integratedService.url.length) {
          window.open(integratedService.url, '_blank')
        } else {
          this.$modal.show('errorMessagePopup')
        }
      } else {
        let headerLinkType = this.headerLinkTypes[type]
        const isIntegrationSelected = ['asana'].includes(type)
        if (isIntegrationSelected) {
          headerLinkType = this.headerLinkTypes.integrations
          this.type = type
        }
        this.$modal.show(headerLinkType)
      }
    },
    asanaSelect (type) {
      if (['open', 'add'].includes(type)) {
        this.onHeaderButtonClick('asana')
      } else if (type === 'detach') {
        this.$modal.show('confirm-asana-modal')
      }
    },
    async detachAsana (confirmVal) {
      if (confirmVal) {
        this.isDataUpdating = true
        await this.detachFromAsana(this.briefId)
        this.isDataUpdating = false
        this.getData()
      }
      this.$modal.hide('confirm-asana-modal')
    },
    async applyAdvancedOptions (options, update = true) {
      this.selectedAdvancedOptions = _.cloneDeep(options)
    },
    async onCommentAdded (commentText) {
      this.isFormProcessing = true
      const comment = {
        comment: commentText,
        author_first_name: '',
        author_last_name: '',
        email: this.userEmail,
        timestamp: new Date().toUTCString()
      }
      await this.addComment({
        briefId: this.briefId,
        comment
      })
      this.isFormProcessing = false
    },
    /**
     * Share brief content callback
     */
    async shareSubmit (shareData) {
      this.$modal.hide('share')
      await this.shareBrief({ shareData, briefId: this.briefId })
      ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Successfully Shared!')
    },
    /**
     * Share pdf callback
     */
    sharePdfSubmit (pdfData) {
      this.$modal.hide('pdf')
      this.sharePdf({ pdfData, briefId: this.briefId })
        .then(res => ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Successfully emailed!'))
        .catch(e => {
        })
    },
    async changeContentBriefContributor ({ key, id }) {
      if (key === 'fk_user_id_writer') {
        let writingStatus = null
        if (id < 0) {
          writingStatus = this.writingStatusOptions.find(status => status.label.toLowerCase() === 'unassigned').value
        } else {
          writingStatus = this.writingStatusOptions.find(status => status.label.toLowerCase() === 'assigned').value
        }
        this.briefContent.writing_status_id = writingStatus
        this.changeWritingStatus({
          url_id: this.briefContent.url_id,
          writing_status: writingStatus,
          raiseError: false,
          successMessage: false
        })
      }
      await this.changeContentBrief({
        clientId: this.clientId,
        briefId: this.briefContent._id,
        [key]: id
      })
    },
    // async changeSlugName (newName) {
    //   const payload = {
    //     clientId: this.clientId,
    //     briefId: this.briefContent._id,
    //     name: newName
    //   }
    //   try {
    //     await this.changeContentBrief(payload)
    //   } catch (e) {
    //     // this.isDataUpdating = false
    //   }
    // },
    shareCancel () {
      this.$modal.hide('share')
    },
    pdfCancel () {
      this.$modal.hide('pdf')
    },
    closeIntegrationChange (update) {
      this.$modal.hide('integrations')
      update && this.getData()
    },
    async getData (reset = true) {
      try {
        await this.getBriefContent({
          briefId: this.briefId,
          reset,
          clientId: this.clientId
        }).then(res => {
          this.isDataFetched = true
          this.isDataUpdating = false
        })
      } catch {
        this.$router.replace('/strategy/url-planner')
        return
      }
      this.getWordCloud(this.briefId)
      this.getComments({ briefId: this.briefId })
    },
    /**
     * Callback for open change brief/url status modal
     * @param type {@see #STATUS_TYPES}
     */
    openChangeStatusModal (type) {
      this.changingType = type
      this.$modal.show('change-status')
    },
    async changeStatus (data) {
      this.$modal.hide('change-status')
      if (data) {
        let { type, statusId, date, description } = data
        const payload = {
          clientId: this.clientId,
          briefId: this.briefContent._id
        }
        if (type === STATUS_TYPES.BRIEF_STATUS) {
          payload.briefStatusId = statusId
          payload.description = description
        } else if (type === STATUS_TYPES.URL_STATUS) {
          payload.urlStatusId = statusId
          payload.description = description
        } else if (type === STATUS_TYPES.OPTIMIZED_STATUS) {
          payload.is_optimized = statusId
          payload.description = description
        }
        if (date && Moment(date).isValid()) {
          date = Moment(date).format('YYYY-MM-DD')
          payload.date = date
        } else if (date === 'clear') {
          payload.date = date
        }
        try {
          // this.isDataUpdating = true
          await this.changeContentBrief(payload)
          this.getComments({ briefId: this.briefId })
          if (type === STATUS_TYPES.URL_STATUS && payload.urlStatusId === '310127d0adb24303b0108db0b00a1858') {
            this.getData(false)
          }
        } catch (e) {
          // this.isDataUpdating = false
        }
      }
    },
    // /**
    //  * callback for click on Agent Mode button. Available only for Reflexive users
    //  */
    // onAgentMode () {
    //   let path = `${window.location.origin}/content_brief/edit?id=${this.briefId}`
    //   window.open(path, '_blank')
    // },
    /**
     * Callback invoked by changing Keyword score in {@link Keywords} component from {@link StrategyTab}
     * @param keyword
     * @returns {Promise<void>}
     */
    async onScoreUpdated (keyword) {
      const payload = {
        clientId: this.clientId,
        briefId: this.briefContent._id,
        score: keyword.score,
        keywordId: keyword._id,
        diff_score: keyword.diff_score,
        is_diff_update: keyword?.isDiffScoreUpdate ? 1 : 0
      }
      try {
        // this.isDataUpdating = true
        await this.updateScore(payload)
        if (!keyword?.isDiffScoreUpdate) {
          await this.getWordCloud(this.briefId)
        }
        // await this.getData(false)
      } catch (e) {
        // this.isDataUpdating = false
      }
    },
    openUrlAttributesModal () {
      this.$modal.show('url-attributes')
    },
    closeUrlAttributesModal (isSomethingChanged) {
      if (isSomethingChanged) {
        this.getData(false)
      }
      this.$modal.hide('url-attributes')
    },
    closeErrorMessagePopup () {
      this.$modal.hide('errorMessagePopup')
    },
    openAttachmentsModal() {
      this.$modal.show('attachmetns')
    },
    closeAttachmentsModal() {
      this.$modal.hide('attachmetns')
    },
    updateUrl(newUrl, newPublishedUrl) {
      this.changeContentBrief({
        clientId: this.clientId,
        briefId: this.briefId,
        url: newUrl,
        url_id: this.briefContent.url_id,
        published_url: newPublishedUrl
      })  
    }
  },
  watch: {
    integrationError: {
      handler (value) {
        if (value) {
          ToasterService.showToast(ToasterService.ERROR_TYPE, value)
          // remove err from url
          this.$router.push(this.$route.path)
        }
      },
      immediate: true
    },
    '$route.name': {
      handler (value) {
        let selectedAdvancedOptions = _.cloneDeep(this.selectedAdvancedOptions)

        if (['briefreporting', 'briefreportingprint'].includes(value.toLowerCase())) {
          const listOfOptions = [ADVANCED_OPTION_TYPE.SCORE, ADVANCED_OPTION_TYPE.SERP_FEATURE, ADVANCED_OPTION_TYPE.MISMATCHED_URLS]
          selectedAdvancedOptions = selectedAdvancedOptions.filter(item => listOfOptions.includes(item.type))
        }

        const advancedOptions = selectedAdvancedOptions.map(item => {
          return {
            selectedField: item.selectedField,
            selectedFilter: item.selectedFilter,
            selectedOperator: item.selectedOperator
          }
        })
        const filters = JSON.stringify({ filters: advancedOptions })
        this._advancedFilters = filters
      }
    },
    clientId: {
      handler (value) {
        const redirectUrl = `${window.location.origin}/integrations/asana/oauth`
        const state = JSON.stringify({
          'client_id': value,
          'redirect_url': redirectUrl,
          'current_route': this.$route.fullPath
        })
        this.integrationLinks = {
          'asana': `https://app.asana.com/-/oauth_authorize?client_id=1170381332056778&redirect_uri=${redirectUrl}&response_type=code&state=${state}`
        }
      },
      immediate: true
    },
    isCurrentSessionFetched: {
      handler (isFetched) {
        if (isFetched) {
          this.getData()
          // this.getSession({ clientId: this.selectedClient._id })
        }
      },
      immediate: true
    },
    selectedClient (newClient, oldClient) {
      if (newClient && newClient.changedFromNavbar) {
        this.$router.replace({ path: '/' })
      }
    }
  }
}

/**
 * fnction manages style of {@link Comments} component
 * @param isCommentsSectionActive
 */
function rightMenuToggleStyles (isCommentsSectionActive, isDestroy = false) {
  const [mainLayout] = document.getElementsByClassName('main-layout__content')
  if (!mainLayout) {
    return
  }
  const [html] = document.getElementsByTagName('html')
  const rootDiv = document.getElementById('app')
  const [briefContent] = document.getElementsByClassName('brief-content')
  const [footer] = document.getElementsByClassName('footer')
  const [container] = document.getElementsByClassName('container')
  if (!isCommentsSectionActive) {
    html.style.paddingRight = '370px'
    html.style.paddingTop = '60px'
    html.style.overflow = 'hidden'
    document.body.style.overflow = 'auto'
    document.body.style.height = '100%'
    rootDiv.style.position = 'relative'
    rootDiv.style.paddingBottom = '40px'
    rootDiv.style.boxSizing = 'border-box'
    // briefContent && (briefContent.style.paddingRight = '0')
    briefContent && (briefContent.style.width = '100%')
    briefContent && (briefContent.style.overflowX = 'auto')
    mainLayout.style.padding = '0 0 50px 250px'
    footer.style.bottom = '62px'
    container.style.minWidth = '1024px'
  } else {
    html.style.paddingRight = null
    html.style.paddingTop = null
    html.style.overflow = 'auto'
    document.body.style.height = null
    // briefContent && (briefContent.style.paddingRight = '48px')
    briefContent && (briefContent.style.width = null)
    briefContent && (briefContent.style.overflowX = null)
    rootDiv.style.position = 'relative'
    rootDiv.style.paddingBottom = '0'
    rootDiv.style.boxSizing = null
    mainLayout.style.padding = !isDestroy ? '60px 0 50px 250px' : ''
    footer.style.bottom = '0'
    container.style.minWidth = null
  }
}

function getDayFromTimestamp (timestamp) {
  return Moment(timestamp).startOf('day').format()
}

function groupCommentsByDate (comments) {
  return comments.reduce((commentsDictionary, comment) => {
    let date = getDayFromTimestamp(comment.timestamp)
    if (!commentsDictionary[date]) {
      commentsDictionary[date] = []
    }
    commentsDictionary[date].push(comment)

    return commentsDictionary
  }, {})
}

function sortCommentsByTimestamp (comments) {
  comments = [...comments]
  comments.sort((comment1, comment2) => {
    const date1 = Moment(comment1.timestamp)
    const date2 = Moment(comment2.timestamp)
    if (date1.isBefore(date2)) {
      return 1
    }

    if (date1.isAfter(date2)) {
      return -1
    }

    return 0
  })

  return comments
}

</script>

<style scoped lang="scss">

  .hide {
    display: none;
  }

  .highlight-msg-icon {
    color: $rfx-bright-turquoise;
  }

  .brief-content {
    padding-bottom: $rfx-bottom-padding;

    &__reporting{
    }

    &__advanced {
      margin: 14px 0;
    }

    &__tabs {
      height: 40px;
      margin-right: 24px;
      display: flex;
      gap: 10px;
    }

    &__content-holder {
      padding: 10px;
      border-radius: 5px;
      border: 1px solid $rfx-silver;
      background: $rfx-almost-white;
      box-sizing: border-box;
      margin: 0 -10px -10px;
      min-width: 990px;
    }

    &__buttons_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 32px;
    }

    &__tab {
      font-weight: 500;
      outline: none;
      font-size: 10px;
      border: none;
      color: $rfx-shaded-grey;
      margin: 0 0 -1px;
      border-radius: 5px 5px 0 0;
      cursor: pointer;
      transition: box-shadow .3s;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #dbdee5;
      text-decoration: none;
      padding: 0 10px;
      border: 1px solid $rfx-silver;
      position: relative;
      z-index: 1;


      &:hover{
        box-shadow: 0 0 7px 0 rgba(33,33,33,.2);
      }

      &_active {
        background-color: $rfx-almost-white;
        border-bottom-color: $rfx-almost-white;
        color: $rfx-medium-march;
        opacity: 1;

        &:hover {
          box-shadow: none;
        }
      }
      &_disabled {
        pointer-events: none;
        cursor: default;
      }
    }

    &__common-info-wrapper {
      display: flex;
      align-items: center;
    }

    &__button-admin {
      background-color: #fff;
      color: $rfx-bright-blue;
      height: 40px;
      padding: 0 15px;
      font-weight: 900;
    }

    &__container {
    }

    &__menu {

    }

    &__right-menu {
      position: fixed;
      display: flex;
      z-index: 25;
      top: 0;
      width: 250px;
      right: 250px;
      flex-direction: column;
      align-items: flex-end;
    }

    &__msg-icon {
      position: absolute;
      left: -250px;
      width: 40px;
      height: 40px;
      box-sizing: border-box;
      padding: 17px 7px;
      font-size: 20px;
      color: $rfx-medium-march;

      &:hover {
        cursor: pointer;
      }
    }

    &__asana-icon {
      position: absolute;
      margin: 5px;
      height: 40px;
      border-radius: 4px;
      border: 2px solid #ededed;
      background-color: white;
      box-sizing: border-box;
      padding: 10px;
      color: $rfx-medium-march;

      &:hover {
        cursor: pointer;
      }
    }

    &__overlay {
      position: fixed;
      z-index: 23;
      background: rgba(1, 22, 39, 0.16);
      top: 0;
      left: 0;
      height: 100%;
      width: calc(100% - 370px);
    }

    &__comments {
      height: 100%;
      width: 372px;
      position: absolute;
      top: 0;
      right: 0px;

      box-shadow: -7px 0 32px 0 rgba(1, 22, 39, 0.16);
      z-index: 10;
      background-color: #f8f8f8;
    }

    &__title {
      position: relative;
      flex: 1;
    }

    &__header {
      display: flex;
      margin-top: 16px;
      align-items: center;
    }

    &__comments-count {
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      text-align: center;
      line-height: 24px;
      color: #fff;
      background-color: $rfx-bright-turquoise;
    }

    &__loader {
      display: flex;
      width: 100%;
      justify-content: center;
      height: calc(100vh - 530px);
      align-items: center;
    }

    &__update-loader {
      position: fixed;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 0;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 300px;
    }

  }

  .brief-content__print {
    padding-bottom: 0;

    .container {
      width: calc(100% - 60px);
    }
  }

  @media print {
    @page {
      margin: 0;
      size: auto;
    }
  }
</style>
